import React, { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { listMembers, updateMemberRole, removeMember } from "../../services/memberService";
import InviteModal from "../../components/InviteModal/InviteModal";
import styles from "./Team.module.css";

const ROLE_LABEL = { OWNER: "Proprietário", ADMIN: "Admin", MEMBER: "Membro" };
const ROLE_OPTIONS = ["ADMIN", "MEMBER"];

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInvite, setShowInvite] = useState(false);

  const fetchMembers = useCallback(async () => {
    try {
      setLoading(true);
      const res = await listMembers();
      setMembers(res.data);
    } catch {
      toast.error("Erro ao carregar membros.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchMembers(); }, [fetchMembers]);

  const handleRoleChange = async (userId, role) => {
    try {
      await updateMemberRole(userId, role);
      toast.success("Role atualizado.");
      fetchMembers();
    } catch {
      toast.error("Erro ao atualizar role.");
    }
  };

  const handleRemove = async (userId, name) => {
    if (!window.confirm(`Remover ${name} do time?`)) return;
    try {
      await removeMember(userId);
      toast.success("Membro removido.");
      fetchMembers();
    } catch {
      toast.error("Erro ao remover membro.");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Equipe</h1>
        <button className={styles.inviteBtn} onClick={() => setShowInvite(true)}>
          + Convidar membro
        </button>
      </div>

      {loading ? (
        <p className={styles.loading}>Carregando...</p>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome</th>
              <th>E-mail</th>
              <th>Role</th>
              <th>Desde</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {members.map((m) => (
              <tr key={m.id}>
                <td>{m.user?.name ?? "—"}</td>
                <td>{m.user?.email}</td>
                <td>
                  {m.role === "OWNER" ? (
                    <span className={styles.badgeOwner}>{ROLE_LABEL[m.role]}</span>
                  ) : (
                    <select
                      value={m.role}
                      onChange={(e) => handleRoleChange(m.userId, e.target.value)}
                      className={styles.roleSelect}
                    >
                      {ROLE_OPTIONS.map((r) => (
                        <option key={r} value={r}>{ROLE_LABEL[r]}</option>
                      ))}
                    </select>
                  )}
                </td>
                <td>{new Date(m.joinedAt).toLocaleDateString("pt-BR")}</td>
                <td>
                  {m.role !== "OWNER" && (
                    <button
                      className={styles.removeBtn}
                      onClick={() => handleRemove(m.userId, m.user?.name)}
                    >
                      Remover
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {showInvite && (
        <InviteModal
          onClose={() => setShowInvite(false)}
          onSuccess={() => { setShowInvite(false); fetchMembers(); }}
        />
      )}
    </div>
  );
}
